module.exports = __webpack_public_path__ + "2ee2d8bebdf1602ce3a1fda0ced156a3.svg";